// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3eRbX","alertIcon":"ConfirmModal_alertIcon__1FW67"};